export const BASE_URL = "https://data.realtorscrm.com/";
// export const BASE_URL = "https://data.realtorscrm.com/";

export const PROPERTY_IMAGES_URL = `${BASE_URL}Images/`;
export const AGENT_IMAGES_URL = `${BASE_URL}AgentImages/`;
export const AGENCY_LOGOS_URL = `${BASE_URL}AgencyLogos/`;
export const AGENCY_WATERMARKS_URL = `${BASE_URL}Agencywatermark/`;
export const AGENCY_LICENSE_IMAGES_URL = `${BASE_URL}AgencyLicensePics/`;
export const PROPERTY_PDFS_URL = `${BASE_URL}pdfs/`;
